import React, { useEffect } from 'react'
import { useAuthStore } from '../../lib/zustand/useAuthStore'
import { useNavigate } from 'react-router-dom'
import { SubmitHandler, useController, useForm } from 'react-hook-form'
import { Input } from 'antd'
import { useLogin } from '../../features/auth'
import ErrorForm from '../../components/atoms/ErrorForm'

export type LoginInputType = {
  username: string
  password: string
}

const LoginPage = () => {
  const { isLogin, setLogin } = useAuthStore()
  const navigate = useNavigate()

  const { control, handleSubmit } = useForm<LoginInputType>()

  const {
    mutate: loginMutate,
    isLoading: loginIsLoading,
    error: loginError,
    isError: loginIsError,
  } = useLogin({
    extendSuccess: () => {
      setLogin()
    },
  })

  const onSubmit: SubmitHandler<LoginInputType> = async (data) => {
    loginMutate(data)
  }

  const { field: fieldUsername } = useController({ name: 'username', control })
  const { field: fieldPassword } = useController({ name: 'password', control })

  useEffect(() => {
    if (isLogin) {
      navigate('/')
    }
  }, [isLogin])
  return (
    <>
      <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-[#f7f7f7] p-3">
        <h1 className="bg-gradient-to-r from-[#B799FF] to-[#AEE2FF] bg-clip-text text-xl font-bold uppercase leading-7 tracking-wide text-transparent">
          Logbook Tegalsari <span className="text-[10px]">v4.0</span>
        </h1>
        <div className="rounded-mdbg-white flex w-full flex-col items-start justify-center bg-white py-7 lg:w-[364px]">
          <h6 className="mb-1 w-full text-center text-[18px] font-bold leading-8 text-[#262627]">
            Hi, Welcome Back!
          </h6>
          <p className="mb-6 w-full text-center text-[14px] leading-5 text-[#77828f]">
            Please login to your account.
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="w-full px-8">
            <div className="flex w-full flex-col gap-4">
              <div className="flex w-full flex-col gap-1">
                <label className="text-sm font-semibold text-[#262627]">Username</label>
                <Input {...fieldUsername} className="w-full" size="large" />
              </div>
              <div className="flex w-full flex-col gap-1">
                <label className="text-sm font-semibold text-[#262627]">Password</label>
                <Input.Password {...fieldPassword} className="w-full" size="large" />
              </div>
              <ErrorForm isShow={loginIsError} message={loginError?.error.details} />
              <div className="mt-3 flex w-full justify-center">
                <button
                  disabled={loginIsLoading}
                  type="submit"
                  className="w-full rounded-md bg-[#B799FF] py-2 text-white"
                >
                  {loginIsLoading ? 'Loading' : 'Submit'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default LoginPage
